import CryptoJS from 'crypto-js'

const aesKey = CryptoJS.enc.Hex.parse('oQJXWQ75sAyGGO7m')
const iv = CryptoJS.enc.Hex.parse('zxcvbnmk09876543')

export default {
  // encrypt
  encryptAes(data:any): string | undefined {
    if (aesKey && data) {
      const plaintext = JSON.stringify(data)
      const srcs = CryptoJS.enc.Utf8.parse(plaintext)
      const encrypted:any = CryptoJS.AES.encrypt(srcs, aesKey, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      return encrypted.ciphertext.toString(CryptoJS.enc.Hex)
    }
  },
  // decrypt
  decryptAes(data:any): string | undefined {
    if (aesKey && data) {
      const encryptedHexStr:any = CryptoJS.enc.Hex.parse(data)
      const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
      const decrypted:any = CryptoJS.AES.decrypt(srcs, aesKey, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      return decrypted.toString(CryptoJS.enc.Utf8)
    }
  }
}
